import React from "react";
import { LoyaltyInfo } from "../../contexts/CustomerContext";
import { formatPoints } from "../../utils/orders";
import styles from "./Portal.module.scss";

interface LoyaltyChipsProps {
  loyalty: LoyaltyInfo | null;
  rewardsReady: number;
}

const LoyaltyChips: React.FC<LoyaltyChipsProps> = ({
  loyalty,
  rewardsReady,
}) => (
  <>
    {loyalty && (
      <div className={styles.LoyaltyChip}>
        <span
          className={styles.LoyaltyDot}
          style={{ backgroundColor: loyalty.tier?.color ?? "#6b7280" }}
        />
        {loyalty.tier ? `${loyalty.tier.name} · ` : ""}
        {formatPoints(loyalty.balance)} pts
      </div>
    )}
    {rewardsReady > 0 && (
      <div className={styles.LoyaltyChip}>
        🎫{" "}
        {rewardsReady === 1 ? "Reward ready" : `${rewardsReady} rewards ready`}
      </div>
    )}
  </>
);

export default LoyaltyChips;
